// extracted by mini-css-extract-plugin
export var chevronIcon = "_95-2";
export var teamName = "_95-1";
export var teamSwitcherButton = "_95-0";